
import dayjs from "dayjs";
import { apiRequest } from "./ApiUtility";

export async function getWorkingHours(auth, userId, selectedDate) {
  if (auth == null || userId == null || selectedDate == null) {
    return { isSuccess: false, data: {} };
  }
  
  const url = "/api/usersettings/getworkinghoursforaday";
  const data = {
    userId,
    facilityId: auth?.selectedFacility?.id,
    selectedDate: dayjs(selectedDate).format("YYYY-MM-DD"),
  };
  
  return await apiRequest("post", url, auth, data);
}